/**
 * code to support product category pages
 *   filtering
 */

// TODO: convert from jquery to pure js

import activeFilterList from '../templates/active-filters.hbs';

const $products = $('.product-tile');
const $buttonFilters = $('.container--active-filters');

// handler filter clicks
const $filters = $('.js-filter-option').on('click', function (e) {
    const $this = $(this);
    e.preventDefault();
    $this.toggleClass('active');
    $('input', $this).prop('checked', $this.hasClass('active'));

    $('.js-expand-all').hide();
    $('.js-clear-all').removeClass('hidden');
    redisplay();
});

$filters.on('keydown', function (e) {
    const key = e.which;
    if (key === 32) {
        // spacebar
        e.preventDefault();
        $(this).trigger('click');
    }
});


// function to show/hide products based on selected filters
function redisplay() {
    // determine active filters
    const activeFilters = [];
    $filters.each(function () {
        const $this = $(this);
        if ($this.hasClass('active')) {
            const value = $this.data('value');
            const filter = $this.closest('.js-filter').data('filter');
            activeFilters.push({
                filter,
                slug: value,
                name: $this.data('displayName'),
            });
        }
    });

    let jqFilter = activeFilters
        .map((x) => `.js-filter-${x.filter}-${x.slug}`)
        // comma makes the filters OR together, removing it makes them ANDed
        // .join(',');
        .join('');
    if (!jqFilter) {
        jqFilter = '*'; // no filters
        $buttonFilters.hide();
    } else {
        $buttonFilters.html(activeFilterList(activeFilters)).addClass('filter-active').show();
    }

    // console.log(jqFilter);
    $products.hide();
    $products.filter(jqFilter).show();


    // update url with selected filters
    const filterObject = {};
    activeFilters.map((x) => {
        if (!filterObject[x.filter]) {
            filterObject[x.filter] = [];
        }
        filterObject[x.filter].push(x.slug);
    });

    const url = new URL(window.location);
    url.search = new URLSearchParams(filterObject);
    window.history.replaceState({}, '', url.toString());
}

// reset filters

// clear all selected filters
const clearAllFilters = (e) => {
    e.preventDefault();
    $filters.removeClass('active');
    $('input', $filters).prop('checked', false);
    redisplay();
    $('.js-clear-all').addClass('hidden');
};
$('.js-clear-all').on('click', clearAllFilters);
$buttonFilters.on('click', '.clear-all-filters', clearAllFilters);

// remove a filter
$buttonFilters.on('click', '.clear-filter', (e) => {
    const filter = $(e.currentTarget).data('filter');
    const $filter = $filters.filter(`[data-value="${filter}"]`);
    $filter.click();
});


// init filtering based on url params
// clear all filters at page load
$('input', $filters).prop('checked', false);
const urlParams = new URLSearchParams(window.location.search);
const $filterTypes = $('.js-filter');
$filterTypes.each((i, term) => {
    // get available filter/param values & check against url params
    const { filter } = term.dataset;
    // find in $filters
    const values = urlParams.get(filter)?.split(',') || [];
    values.forEach((value) => {
        const $filter = $filters.filter(`[data-value="${value}"]`);
        // for each one, activate
        // toggle class to active & input check box
        $filter.click();
    });
})

// Accordion
const $sidebarToggle = $('.js-sidebar-toggle');

$sidebarToggle.on('click', (e) => {
    const $sidebar = $(e.currentTarget).closest('.product-filters');
    $sidebar.toggleClass('active');
});

const $filterToggle = $('.js-filter-toggle');

$filterToggle.on('click', (e) => {
    const $filter = $(e.currentTarget).closest('.product-filters__filter');
    $filter.toggleClass('active');
    if ($filter.is('.active')) {
        $(e.currentTarget).attr('aria-expanded', 'true');
        $filter.find('.js-filter').attr('aria-hidden', 'false');
        $filter.find('button.checkmark').attr('tabindex', '0');
    } else {
        $(e.currentTarget).attr('aria-expanded', 'false');
        $filter.find('.js-filter').attr('aria-hidden', 'true');
        $filter.find('button.checkmark').attr('tabindex', '-1');
    }

    allFiltersOpen();
});

// see if all filters have been opened
function allFiltersOpen() {
    const activeFilters = $('.product-filters__filter.active');
    const allFilters = $('.product-filters__filter');
    if (activeFilters.length === allFilters.length) {
        $('.js-expand-all').hide();
    }
}

// expand all selected filter groups
$('.js-expand-all').on('click', (e) => {
    const $filter = $filterToggle.closest('.product-filters__filter');
    $filter.addClass('active');
    if ($filter.is('.active')) {
        $(e.currentTarget).attr('aria-expanded', 'true');
        $filter.find('.js-filter').attr('aria-hidden', 'false');
        $filter.find('button.checkmark').attr('tabindex', '0');
    }
    $('.js-expand-all').hide();
});

function gazeStars(starVar) {
    const productGrid = document.querySelector('.products-grid');

    if (productGrid && starVar === true) {
        productGrid.classList.add('show-stars');
    }
}

function activateStars() {
    gazeStars(GLAD_GLOBAL.stars);
}

window.activateStars = activateStars;
